import { useTheme } from '@mui/material'

/**
 * Hook to get status colors from the theme.
 * @returns {object} Map of status codes to theme colors.
 */
export const useStatusColors = () => {
  const theme = useTheme()
  return {
    ACTIVE_EXECUTION: theme.palette.success.main,
    ACTIVE_PREPARATION: theme.palette.info.main,
    WAITING: theme.palette.warning.main,
    INTERRUPTED: theme.palette.warning.dark,
    CANCELED: theme.palette.error.main
  }
}
